import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useAuthenticator } from "@aws-amplify/ui-react";
import ContentLayoutFooterNoChartreuse from "../components/Layout/ContentLayoutFooterNoChartreuse";

function Press() {
  const { authStatus, user } = useAuthenticator((context) => [
    context.authStatus,
    context.user,
  ]);

  const router = useRouter();

  useEffect(() => {
    // Check if authStatus is 'unauthenticated' or if user is not available
    if (authStatus === "unauthenticated") {
      router.push("/login");
    }
  }, [authStatus, user, router]);

  return (
    <ContentLayoutFooterNoChartreuse title="Press">
      <div className="flex flex-col items-center justify-center overflow-hidden mt-32">
        <h1 className="text-2xl mb-6">Press</h1>
        <div className="flex flex-col">
          <h5> Please reach out to press@raraity.com</h5>
        </div>
      </div>
    </ContentLayoutFooterNoChartreuse>
  );
}

export default Press;

export async function getStaticProps() {
  return {
    props: { page: "Press" },
  };
}
